import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div>\n    <section class=\"loader\">\n        <div class=\"loading-blocker\"></div>\n    </section>\n\n    <section class=\"row\">\n        <div class=\"column small-centered small-4\">\n            <p class=\"default\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"defaultMessage") : stack1), depth0))
    + "</p>\n            <p class=\"rates-update hide\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"ratesUpdateCall") : stack1), depth0))
    + "</p>\n        </div>\n    </section>\n</div>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/spinner-module",
  "version": "1.0.1",
  "id": "spinnerModule",
  "containerID": "homeLoansSpinnerModule",
  "moduleName": "home-loans-spinner-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "spinner-module",
  "data": {
    "init": "spinnerModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/**
 * @export
 * @class spinnerModule
 * @extends {Module}
 */
class spinnerModule extends Module {
  /**
   * Creates an instance of AffordabilityBudgetModule.
   * @param {Object} options Module option
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // Jquery object for wrapper
    this.$target = $('#spinnerModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method fadeOutModule
   * @return {void}
   */
  fadeOutModule() {
    // fade in
    this.$target.fadeOut(200);

    // add hide
    this.$target.addClass('hide');

    // add class
    this.$target.removeClass('todo-active');
  }

  /**
   * @method fadeInModule
   * @return {void}
   */
  fadeInModule() {
    // fade in
    this.$target.fadeIn(200);

    // add class
    this.$target.addClass('todo-active');
  }

  /**
   * @return {void}
   */
  updateSpinnerRatesText() {
    // show rates wording
    let $cache = this.$target.find('.rates-update');
    $cache.show();

    // hide default
    $cache = this.$target.find('.default');
    $cache.hide();
  }

  /**
   * @return {void}
   */
  init() {
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_SUCCESS', this.fadeOutModule);
    this.Events.sub('HOME_LOANS_MORTGAGE_RATES_REQUEST_FAILURE', this.fadeOutModule);
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_SUCCESS', this.fadeOutModule);
    this.Events.sub('HOME_LOANS_REFINANCE_RATES_REQUEST_FAILURE', this.fadeOutModule);
    this.Events.sub('HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_SUCCESS', this.fadeOutModule);
    this.Events.sub('HOME_LOANS_ASSUMPTIONS_RATES_REQUEST_FAILURE', this.fadeOutModule);
  }
}
registerModuleClass({
  moduleClass: spinnerModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { spinnerModule as default, moduleConfig };
